import { createComponent } from '@carvana/merch-components';
import TrackWrapper, { TrackWrapperProps } from '../common/TrackWrapper';

export const SemOuterTrackWrapper = createComponent<TrackWrapperProps>(
  TrackWrapper,
  () => ({
    className: `
    bg-white
    px-24
    py-24
    odd:bg-white
    even:bg-grey-1
    m:py-40
    [&:nth-child(even)_.target]:bg-white
    [&:nth-child(odd)_.target]:bg-grey-1
 `
  })
);

export const CommonModuleInner = createComponent('div', {
  className:
    'mx-auto max-w-[425px] flex-col -:flex -:items-center -:gap-24 m:max-w-[1144px]'
});

export const SectionTitle = createComponent('h2', {
  className: 'text-blue-6 tl-header-xl'
});

export const SectionSubtitle = createComponent('p', {
  className: '!font-normal !normal-case text-grey-5 tl-label-l'
});
